import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore,
} from 'oidc-client-ts';
import { clearToken, setToken } from './token';
const BASE_URI = `${window.location.origin}`;
const oidcSettings: UserManagerSettings = {
  authority: OIDC_URL,
  client_id: OIDC_CLIENT_ID,
  redirect_uri: BASE_URI + OIDC_REDIRECT_URL,
  post_logout_redirect_uri: BASE_URI + OIDC_REDIRECT_LOGIN_URL,
  response_type: 'code',
  scope: 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
export const oidcClient = new UserManager(oidcSettings);
export async function toSignInRedirect() {
  clearToken();
  await oidcClient.signinRedirect();
}
// 注销用户并重定向到登录页面
export async function logoutAndRedirect() {
  await oidcClient.signoutRedirect();
  clearToken();
}
export async function signinRedirectCallback() {
  try {
    const user = await oidcClient.signinRedirectCallback();
    console.log("🚀 ~ signinRedirectCallback ~ user:", user)
    if (user && user.access_token) {
      await setToken(user);
    }
    return user;
  } catch (e) {
    console.log("🚀 ~ signinRedirectCallback ~ e:", e)
    throw e;
  }
}

